/// <amd-module name="SuiteCommerce.StockNotifications.PDP"/>
define("SuiteCommerce.StockNotifications.PDP", ["require", "exports", "SuiteCommerce.StockNotifications.PDP.View", "SuiteCommerce.StockNotifications.PDP.Model"], function (require, exports, PDP_View_1, PDP_Model_1) {
    "use strict";
    return {
        mountToApp: function mountToApp(container) {
            var pdp = container.getComponent('PDP');
            if (pdp) {
                this.addPdpChildView(container, pdp);
            }
        },
        addPdpChildView: function addPdpChildView(container, pdp) {
            pdp.addChildViews(pdp.PDP_FULL_VIEW, {
                'Product.Stock.Info': {
                    'StockNotifications.PDP': {
                        childViewIndex: 10,
                        childViewConstructor: function () {
                            var isInventoryItem = pdp.getItemInfo().item.itemtype === 'InvtPart';
                            if (!pdp.getItemInfo().item.keyMapping_showGrid
                                && isInventoryItem) {
                                return new PDP_View_1.PdpView({
                                    pdp: pdp,
                                    container: container,
                                    model: new PDP_Model_1.PdpModel()
                                });
                            }
                            return null;
                        }
                    }
                }
            });
        }
    };
});
